import { render, staticRenderFns } from "./SpedizioniMin.vue?vue&type=template&id=557233e0"
import script from "./SpedizioniMin.vue?vue&type=script&lang=js"
export * from "./SpedizioniMin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports